import { BrandData, ConnectionStatus } from '../providers/brand-access.service';
import { FeaturedBrand } from 'shared/models/brand/types';
import { BrandAccessRight } from '../types';

export type Brand = BrandData | FeaturedBrand;

export enum BrandSearchSection {
    YourResults = 'yourResults',
    FeaturedBrands = 'featuredBrands',
    OtherResults = 'otherResults',
    YourBrandsWithAccess = 'yourBrandsWithAccess'
}

export enum FcProducts {
    Content = 'content',
    Reorder = 'reorder',
    Preorder = 'preorder',
    AutoRestock = 'auto-restock',
    Suggestions = 'suggestions'
}

export type SelectedProduct = FcProducts | 'all';

export type FcProductListItem = {
    index: number;
    product: FcProducts;
    icon?: string;
    translationKey: string;
    defaultAccessRight?: BrandAccessRight; // Used to determine the product page link
    relatedAccessRight?: BrandAccessRight[];
};

export type BrandRelatedFcProduct = {
    index: FcProductListItem['index']; // Used for sorting. Order is based on this index value in the productList
    productId: FcProductListItem['product'];
    label: FcProductListItem['translationKey'];
};

export type SelectedBrandEvent<T extends Brand> = {
    brand: BrandSearchResult<T>;
    product: FcProductListItem['product'];
    brandWithAccess: boolean;
};

export type FcProductPageRoute = {
    urlFragments: any[];
    queryParams?: { [key: string]: string | number };
};

export type BrandSearchResult<T extends Brand> = T & {
    _id: BrandData['_id'];
    name: BrandData['name'];
    connectionStatus: ConnectionStatus;
    hasAutoRestockConnection: boolean;
    hasSuggestionConnection: boolean;
    isAutoRestockEnabled?: boolean;
    openSuggestionsCount: string;
};
